"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _strengthMap;

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var LSCGSolver = require("lscg-solver");

var common_1 = require("../common");

var abstract_1 = require("./abstract");

function initialize() {
  return LSCGSolver.initialize();
}

exports.initialize = initialize;
exports.Matrix = LSCGSolver.Matrix;
var strengthMap = (_strengthMap = {}, _defineProperty(_strengthMap, abstract_1.ConstraintStrength.HARD, LSCGSolver.ConstraintSolver.STRENGTH_HARD), _defineProperty(_strengthMap, abstract_1.ConstraintStrength.STRONG, LSCGSolver.ConstraintSolver.STRENGTH_STRONG), _defineProperty(_strengthMap, abstract_1.ConstraintStrength.MEDIUM, LSCGSolver.ConstraintSolver.STRENGTH_MEDIUM), _defineProperty(_strengthMap, abstract_1.ConstraintStrength.WEAK, LSCGSolver.ConstraintSolver.STRENGTH_WEAK), _defineProperty(_strengthMap, abstract_1.ConstraintStrength.WEAKER, LSCGSolver.ConstraintSolver.STRENGTH_WEAKER), _strengthMap);

var WASMSolver =
/*#__PURE__*/
function (_abstract_1$Constrain) {
  _inherits(WASMSolver, _abstract_1$Constrain);

  function WASMSolver() {
    var _this;

    _classCallCheck(this, WASMSolver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WASMSolver).call(this));
    _this.currentIndex = 0;
    _this.softInequalities = [];
    _this.variables = new common_1.KeyNameMap();
    _this.solver = new LSCGSolver.ConstraintSolver();
    _this.solver.flags = LSCGSolver.ConstraintSolver.FLAG_REDUCE; // | LSCGSolver.ConstraintSolver.FLAG_LAGRANGE;

    _this.solver.tolerance = 1e-8;
    return _this;
  }

  _createClass(WASMSolver, [{
    key: "makeConstant",
    value: function makeConstant(map, name) {
      this.solver.makeConstant(this.attr(map, name).index);
    }
    /** Get the variable of an attribute */

  }, {
    key: "attr",
    value: function attr(map, name, options) {
      if (this.variables.has(map, name)) {
        return this.variables.get(map, name);
      } else {
        this.currentIndex++;
        var item = {
          index: this.currentIndex,
          map: map,
          name: name
        };
        this.variables.add(map, name, item);
        var value = +map[name]; // Safety check: the solver won't like NaNs

        if (isNaN(value)) {
          value = 0;
        }

        this.solver.addVariable(this.currentIndex, value, options ? options.edit : false);

        if (!options) {
          console.warn("Creating new attr ".concat(name, " without options"));
        }

        return item;
      }
    }
    /** Get the value of a variable */

  }, {
    key: "getValue",
    value: function getValue(attr) {
      return attr.map[attr.name];
    }
    /** Set the value of a variable */

  }, {
    key: "setValue",
    value: function setValue(attr, value) {
      attr.map[attr.name] = value;
    }
    /** Add a linear constraint */

  }, {
    key: "addLinear",
    value: function addLinear(strength, bias, lhs, rhs) {
      var st = strengthMap[strength];
      var weights = [];
      var variable_names = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = lhs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _item = _step.value;
          weights.push(_item[0]);
          variable_names.push(_item[1].index);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (rhs) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = rhs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;
            weights.push(-item[0]);
            variable_names.push(item[1].index);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      this.solver.addConstraint(st, bias, variable_names, weights);
    }
    /** Add a soft inequality constraint: bias + linear(lhs) >= linear(rhs) */

  }, {
    key: "addSoftInequality",
    value: function addSoftInequality(strength, bias, lhs, rhs) {
      var st = strengthMap[strength];
      var weights = [];
      var variable_names = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = lhs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _item2 = _step3.value;
          weights.push(_item2[0]);
          variable_names.push(_item2[1].index);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (rhs) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = rhs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;
            weights.push(-item[0]);
            variable_names.push(item[1].index);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      var id = this.solver.addConstraint(st, bias, variable_names, weights);
      this.softInequalities.push({
        id: id,
        bias: bias,
        variable_names: variable_names,
        weights: weights
      });
    }
    /** Solve the constraints */

  }, {
    key: "solve",
    value: function solve() {
      var _this2 = this;

      this.variables.forEach(function (value, map, key) {
        _this2.solver.setValue(value.index, map[key]);
      });
      this.solver.regularizerWeight = 0.001;
      var maxIters = 10;

      for (var iter = 0; iter < maxIters; iter++) {
        this.solver.solve();
        var shouldReiterate = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = this.softInequalities[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var soft = _step5.value;
            var value = soft.bias;

            for (var i = 0; i < soft.variable_names.length; i++) {
              value += this.solver.getValue(soft.variable_names[i]) * soft.weights[i];
            }

            if (value >= -1e-6) {
              this.solver.setConstraintStrength(soft.id, LSCGSolver.ConstraintSolver.STRENGTH_DISABLED);
            } else {
              shouldReiterate = true;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        if (!shouldReiterate) {
          break;
        }

        if (iter == maxIters - 1) {
          console.warn("Soft inequalities didn't converge within ".concat(maxIters, " iterations"));
        }
      }

      this.variables.forEach(function (value, map, key) {
        map[key] = _this2.solver.getValue(value.index);
      });
      return [0, this.solver.error];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.solver.destroy();
    }
  }]);

  return WASMSolver;
}(abstract_1.ConstraintSolver);

exports.WASMSolver = WASMSolver;